<template>
  <b-modal
    footer-class="removed"
    title="معلومات التبرع"
    v-model="isModalShown"
    centered
    static
    size="lg"
  >
    <form-wizard
      stepSize="sm"
      color="#28c76f"
      :title="null"
      :subtitle="null"
      shape="circle"
      finish-button-text="إنهاء"
      back-button-text="السابق"
      next-button-text="التالي"
      class="mb-3"
      :validateOnBack="false"
      @on-complete="isModalShown = false"
    >
      <tab-content :before-change="validateFirstStep" lazy>
        <ValidationObserver ref="paymentFormValidaion">
          <b-form @submit.prevent>
            <form-cleave
              v-model="number"
              rules="required"
              label="رقم الهاتف"
              isNumber
              :charsCount="10"
            />
            <form-currency
              v-model="amount"
              rules="required"
              label="قيمة المبلغ"
            />
          </b-form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateLastStep" lazy>
        <validation-observer ref="codeValidation">
          <div class="h4 text-center code-title mb-4">
            لقد أرسلنا إلى الرقم :
            <span class="text-info font-weight-bold">
              {{ number }}
            </span>
            رسالة نصية تحوي رمز تأكيد مكون من 5 أرقام , يرجى إدخال الرمز في
            الحقل أدناه.
          </div>
          <div class="w-100">
            <form-cleave
              dir="ltr"
              id="verification-code"
              v-model="code"
              class="text-center d-block my-2 mx-auto w-25"
              isNumber
              :charsCount="6"
            />
            <img
              class="mx-auto d-block"
              style="width: 40%; height: 40%"
              :src="
                require('@/assets/images/illustration/sms-verification.svg')
              "
            />
          </div>
        </validation-observer>
      </tab-content>
    </form-wizard>
  </b-modal>
</template>

<script>
import { BModal, BForm, BButton, BCol, BFormRow } from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import FormCleave from "@/components/FormCleave.vue";
import FormCurrency from "@/components/FormCurrency.vue";
import LoaderBtn from "@/components/loader-btn.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BModal,
    BForm,
    BButton,
    BCol,
    BFormRow,
    ValidationObserver,
    FormCleave,
    FormCurrency,
    LoaderBtn,
    FormWizard,
    TabContent,
  },
  props: {
    value: Boolean,
    method: String,
    methodId: Number,
  },
  data() {
    return {
      number: null,
      amount: null,
      code: null,
      transactionUUID: null,
    };
  },

  watch: {
    isModalShown() {
      this.number = null;
      this.amount = null;
      this.code = null;
      this.transactionUUID = null;
    },
  },
  methods: {
    ...mapActions("NgoHome/donationNgo", [
      "validatePaymentInfo",
      "finalizePayment",
    ]),
    validateFirstStep() {
      return new Promise(async (resolve, reject) => {
        await this.$refs.paymentFormValidaion
          .validate()
          .then(async (success) => {
            if (success) {
              this.$bvModal
                .msgBoxConfirm(
                  `سيتم اقتطاع مبلغ : ${new Intl.NumberFormat().format(
                    this.amount
                  )} ل.س من الحساب صاحب الرقم ${
                    this.number
                  } و تحويله إلى حساب المنظمة .\n هل أنت متأكد من الاستمرار ؟`,
                  {
                    title: "تأكيد معلومات التبرع",
                    size: "sm",
                    okVariant: "warning",
                    okTitle: "تأكيد",
                    cancelTitle: "إلغاء",
                    cancelVariant: "outline-secondary",
                    hideHeaderClose: false,
                    centered: true,
                  }
                )
                .then(async (value) => {
                  if (value) {
                    await this.validatePaymentInfo({
                      number: this.number,
                      amount: this.amount,
                      methodId: this.methodId,
                    })
                      .then((res) => {
                        this.transactionUUID = res.data.data.transaction_id;
                        resolve(true);
                      })
                      .catch((err) => {
                        var errText = "";
                        if (err.message && err.message.includes("not merchant"))
                          errText = "الرقم المدخل غير صالح لعملية التبرع";
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: "حدث خطأ أثناء عملية التبرع",
                            icon: "AlertCircleIcon",
                            variant: "danger",
                          },
                        });
                        reject(false);
                      });
                  } else reject(false);
                });
            } else {
              reject(false);
            }
          });
      });
    },
    validateLastStep() {
      return new Promise(async (resolve, reject) => {
        await this.$refs.codeValidation.validate().then(async (success) => {
          if (success) {
            this.$bvModal
              .msgBoxConfirm(
                `سيتم التبرع بمبلغ : ${new Intl.NumberFormat().format(
                  this.amount
                )} ل.س من الحساب صاحب الرقم ${
                  this.number
                }  إلى حساب المنظمة .\n هل أنت متأكد من الاستمرار ؟ \n\n ملاحظة : لا يمكن التراجع عن هذه العملية بمجرد اتمامها`,
                {
                  title: "تأكيد إتمام العملية",
                  size: "sm",
                  okVariant: "danger",
                  okTitle: "تأكيد",
                  cancelTitle: "إلغاء",
                  cancelVariant: "outline-secondary",
                  hideHeaderClose: false,
                  centered: true,
                }
              )
              .then(async (value) => {
                if (value) {
                  await this.finalizePayment({
                    transactionUUID: this.transactionUUID,
                    methodId: this.methodId,
                    otp: this.code,
                  })
                    .then(() => {
                      resolve(true);
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: "تمت عملية التبرع بنجاح",
                          icon: "CheckSquareIcon",
                          variant: "success",
                          timeout: 3000,
                        },
                      });
                    })
                    .catch((err) => {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: "حدث خطأ أثناء عملية التبرع",
                          icon: "AlertCircleIcon",
                          variant: "danger",
                        },
                      });
                      reject(false);
                    });
                } else reject(false);
              });
          } else {
            reject(false);
          }
        });
      });
    },
  },
  computed: {
    isModalShown: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss">
.wizard-icon {
  font-style: normal;
}
.vue-form-wizard .wizard-nav-pills a,
.vue-form-wizard .wizard-nav-pills li {
  cursor: not-allowed;
  pointer-events: none;
}
#verification-code {
  text-align: center;
  font-size: large;
  padding-top: 20px;
  padding-bottom: 20px;
}
.code-title {
  line-height: 150%;
}
</style>
